import styled, { css } from 'styled-components'
import { white, blue, whitegray, bordergray, black, inputgray, red } from '../../styles/colors'
import { minmedia, maxmedia } from '../../styles/media-queries'

export const Intro = styled.div`
  line-height: 1.4;

  width: 100%;

  ${minmedia.xmlarge`
    width: calc(70% - 1rem);
  `};
`

export const Wrapper = styled.div`
  padding: 0 1.5rem;
  background: ${blue};
  color: ${white};
  ${minmedia.large`
    padding: 0;
    padding-bottom: 1.5rem;
  `} ${minmedia.xmlarge`
    padding: 2rem 1.5rem;
  `} ${props =>
      props.firstChild &&
      css`

        ${maxmedia.xmlarge`
      padding-bottom: 1.5rem;
      margin-bottom: 1.5rem;
    `};
      `};

  ${props =>
    props.secondChild &&
    css`
      ${maxmedia.xmlarge`
      display: none;
    `};
    `};

    a {
      color: ${white};
    }
`

export const DayPickerWrapper = styled.div`
  width: 100%;
  .DayPickerInput {
    width: 100%;
  }
  input {
    transition: all 0.5s;
    padding: 0.75rem 1rem;
    font-weight: 300;
    font-size: 18px;
    background: ${whitegray};
    border: 1px solid ${bordergray};
    border-radius: 0.25rem;
    color: ${black};
    display: inline-block;
    width: 100%;
    ${minmedia.medium`
      font-size: 18px;
    `} &:focus {
      border-color: ${inputgray};
      box-shadow: 0px 0px 5px 0px ${inputgray};
      outline: none;
    }
  
    &::-webkit-input-placeholder {
      color: ${inputgray};
    }
    &::-moz-placeholder {
      color: ${inputgray};
      opacity: 1;
    }
    &:-ms-input-placeholder {
      color: ${inputgray};
    }
  }
`

export const StatusBar = styled.div`
  width: 100%;
  padding: 1rem 2rem;
  background: ${red};
  opacity: 0.8;
  border-radius: 0.25rem;
  color: ${white};
  line-height: 1.5;
  width: 100%;
  margin-top: 1rem;
  a {
    color: ${white};
  }
  ${maxmedia.medium`
    font-size: 15px;
    line-height: 1.2;
  `};
  ${minmedia.xmlarge`
    width: calc(70% - 1rem);
  `};
`

export const StyledLink = styled.a`
  color: ${red};
  text-align: center;
  display: block;
  margin: 0 auto;
  margin-top: 1.5rem;
`


// WEBPACK FOOTER //
// ./src/components/ShoppingCartOrders/styles.js